module.exports = __webpack_public_path__ + "img/3.dc7e484b.jpg";